<section>
  <div class="row g-3">
    <div class="col-xl-9 col-xxl-7 col-12 client-add">
      <div class="sana-card mb-3">
        <a
          class="back-hint"
          role="link"
          [routerLink]="['../..']"
          tabindex="0">
          <i class="pi pi-chevron-left"></i> Zurück zur Übersicht
        </a>

        @if (isClientLoaded()) {
          <ng-container [ngTemplateOutlet]="content"></ng-container>
        } @else {
          <sana-tp-sekeleton-loading></sana-tp-sekeleton-loading>
        }
      </div>
    </div>
  </div>
</section>


<ng-template #content>
  <div class="sana-card-header mb-3">
    Neuen Therapieplan für {{ selectedClient().fullNameWithTitle }} erstellen
  </div>

  <div class="sana-card-body">
    <form [formGroup]="form">
      <div class="row gx-3">
        <div class="col-md-6 sana-form-control">
          <label for="joints">
            Betroffene Gelenke *
          </label>

          <p-multi-select
            id="joints"
            [lazy]="true"
            [options]="jointOptionsToSelect()"
            [formControl]="form.controls.selectedJoints"
            optionLabel="type"
            placeholder="Wählen Sie die betroffenen Gelenke aus"
            [fluid]="true"
            [filter]="false"
            [size]="'small'"
            [showToggleAll]="false"
            [emptyMessage]="'Keine Gelenke ausgewählt'"
            [selectedItemsLabel]="'{} ausgewählt'">

            <ng-template
                let-joint
                #item>
              <div class="flex items-center gap-2">
                <div>{{ joint.type }}</div>
              </div>
            </ng-template>

          </p-multi-select>
        </div>

        <div class="col-md-6 sana-form-control">
          <label for="diagnosis">
            Diagnose *
          </label>

          <input
            pInputText
            id="diagnosis"
            [formControl]="form.controls.diagnosisText"
            pSize="small"
            [fluid]="true" />
        </div>

        <div class="col-md-6 sana-form-control">
          <label for="therapyPlanType">Art der Behandlung *</label>

          <p-select
            id="therapyPlanType"
            inputId="therapyPlanType"
            [formControl]="form.controls.therapyPlanType"
            [options]="[TherapyPlanTypeEnum.Surgical, TherapyPlanTypeEnum.Conservative]"
            placeholder="Art der Behandlung"
            size="small"
            [fluid]="true">

            <ng-template
                #selectedItem
                let-selectedEntry>
              {{ TherapyPlanTypeTranslations.getTranslationByKey(selectedEntry) }}
            </ng-template>

            <ng-template
                let-entry
                #item>
              {{ TherapyPlanTypeTranslations.getTranslationByKey(entry) }}
            </ng-template>
          </p-select>
        </div>

        @if (form.controls.therapyPlanType.value === TherapyPlanTypeEnum.Surgical) {
          <div class="col-md-6 sana-form-control">
            <label for="op-method">
              OP Methode
            </label>

            <input
              pInputText
              id="op-method"
              [formControl]="form.controls.surgeryMethodText"
              pSize="small"
              [fluid]="true" />
          </div>
        }

        <div class="col-12">
          <div class="row gy-2 gx-2 justify-content-end">
            @if (previousTherapyPlan()) {
              <div class="col-sm col-md-auto">
                <p-button
                  [fluid]="true"
                  class="ms-auto"
                  size="small"
                  severity="secondary"
                  icon="pi pi-copy"
                  label="Vorherigen Plan übernehmen"
                  (onClick)="applyPreviousPlan()"></p-button>
              </div>
            }

            <div class="col-sm col-md-auto">
              <p-button
                class="ms-auto"
                [fluid]="true"
                size="small"
                severity="primary"
                label="Zu den Übungen"
                icon="pi pi-file"
                (onClick)="routeToExercises()"></p-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
